
const banner_text = `Danish Red Cross has joined the GatwayAPI club!`;

export default {
  'da': {
    'welcome': 'Velkommen til',
    'banner_text': banner_text,
    'building_descriptions': [
      {
        'headline': '<h1><strong>NexCon.io</strong></h1>',
        'desc': '<p><strong>Professionelle simkort til M2M- & IoT enheder.</strong></p><p>Anvend vores simkort til at forbinde dine M2M- og' +
          ' IoT-enheder til over 470 globale netværk, administrer simkort og håndter indgående og udgående kommunikation via dataoverførsel og SMS.</p>',
        'desc_short': '<p><strong>Professionelle simkort til M2M- & IoT enheder.</strong></p><p></p>',
        'btn_text': 'Bliv forbundet',
        'btn_link': 'https://nexcon.io/'
      }, {
        'headline': '<h1><strong>Gateway</strong>API</h1>',
        'desc': '<p><strong>Anvend SMS\'er til at kommunikere med dine kunder nemt og hurtigt via vores state-of-the-art SMS gateway.</strong></p><p>GatewayAPI.com håndterer ugentligt millioner af SMS’er på vegne af tusindvis af kunder verden over – alt fra start-ups til multinationale selskaber. Platformen udmærker sig ved en intuitiv brugerflade, meget høj oppetid, gratis brugerkonto og de laveste SMS-priser i 200+ lande.</p>',
        'desc_short': '<p><strong>Anvend SMS\'er til at kommunikere med dine kunder nemt og hurtigt via vores state-of-the-art SMS gateway.</strong></p><p></p>',
        'btn_text': 'Kom og se',
        'btn_link': 'https://gatewayapi.com/'
      }, {
        'headline': '<h1><strong>Relation</strong>City</h1>',
        'desc': '<p><strong>Styrk relationen til dine kunder via platformen RelationCity, som danner automatiseret, effektiv og målrettet kommunikation baseret på indsamlet data.</strong></p><p>Opret selv en række budskaber, der bliver udløst ud fra forskellige parametre, og ram målgrupperne med et automatisk budskab på de medier, de foretrækker og på det tidspunkt, der passer dem bedst.</p>',
        'desc_short': '<p><strong>Styrk relationen til dine kunder via platformen RelationCity, som danner automatiseret, effektiv og målrettet kommunikation baseret på indsamlet data.</strong></p><p></p>',
        'btn_text': 'Besøg RelationCity',
        'btn_link': 'https://relationcity.com/'
      }
    ]
  },
  'en': {
    'welcome': 'Welcome to',
    'banner_text': banner_text,
    'building_descriptions': [
      {
        'headline': '<h1><strong>NexCon.io</strong></h1>',
        'desc': '<p><strong>Professional SIM cards for use in M2M and IoT devices.</strong></p><p>Use our SIM cards to connect your M2M and IoT devices to over 470 global networks. Manage SIM cards and incoming and outgoing communication via data transfer and SMS.</p>',
        'desc_short': '<p><strong>Professional SIM cards for use in M2M and IoT devices.</strong></p><p></p>',
        'btn_text': 'Get connected',
        'btn_link': 'https://nexcon.io/'
      }, {
        'headline': '<h1><strong>GatewayAPI</strong></h1>',
        'desc': '<p><strong>The best and cheapest SMS Gateway out there! Utilise SMS to communicate with your customers quick and easy with our state-of-the-art SMS gateway.</strong></p><p>Our platform, GatewayAPI.com, handles millions of SMSes every week on behalf of thousands of customers worldwide – everything from start-ups to multinational corporations. GatewayAPI.com sports an intuitive user interface, very high uptime, a free user account and the lowest SMS-prices in over 200+ countries.</p>',
        'desc_short': '<p><strong>The best and cheapest SMS Gateway out there</strong></p><p></p>',
        'btn_text': 'Come on in',
        'btn_link': 'https://gatewayapi.com/'
      }, {
        'headline': '<h1><strong>RelationCity</strong></h1>',
        'desc': '<p><strong>Strengthen your relation to your customers with RelationsCity, that creates automated, effective and extremely targeted communication based on data.</strong></p><p>Generate a number of messages that will be triggered based on different parameters and reach the target audience on those devices they prefer and at the time that suits them best.</p>',
        'desc_short': '<p><strong>Strengthen your relation to your customers with RelationCity, that creates automated, effective and extremely targeted communication based on data.</strong></p><p></p>',
        'btn_text': 'Visit RelationCity',
        'btn_link': 'https://relationcity.com/'
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/multilanguage/city.js